import {
	SSR_CODE_WHEELCHAIR_CARRY,
	SSR_CODE_WHEELCHAIR_RAMP,
	SSR_CODE_WHEELCHAIR_STEPS,
	SSR_CODE_WHEELCHAIR_MANUAL_POWER,
	SSR_CODE_WHEELCHAIR_DRY_CELL_BATTERY,
	SSR_CODE_WHEELCHAIR_WET_CELL_BATTERY,
	SSR_CODE_WHEELCHAIR_LITHIUM_ION_BATTERY,
	SSR_CODE_SPECIAL_NEEDS_SERVICE_ANIMAL,
	SSR_CODE_SPECIAL_NEEDS_BLIND_ASSISTANCE,
	SSR_CODE_SPECIAL_NEEDS_DEAF_ASSISTANCE,
	SSR_CODE_LUGGAGE_BABY_BASKET,
	SSR_CODE_ANIMAL_IN_HOLD,
	SSR_CODE_PET_IN_CABIN,
	SSR_CODE_BAGGAGE_FIRST_BAG,
	SSR_CODE_BAGGAGE_SECOND_BAG,
	SSR_CODE_BAGGAGE_ADDITIONAL_BAG,
	SSR_CODE_BAGGAGE_BULKY_BAG,
	SSR_CODE_FAST_TRACK,
	SSR_CODE_LOUNGE_ACCESS_1,
	SSR_CODE_MEAL_HINDU_VEGETARIAN,
	SSR_CODE_MEAL_BABY,
	SSR_CODE_MEAL_BLAND,
	SSR_CODE_MEAL_CHILD,
	SSR_CODE_MEAL_COLD,
	SSR_CODE_MEAL_SEAFOOD_1,
	SSR_CODE_MEAL_DIABETICS,
	SSR_CODE_MEAL_FRUIT_PLATTER,
	SSR_CODE_MEAL_FISH,
	SSR_CODE_MEAL_GLUTEN_FREE,
	SSR_CODE_MEAL_HINDU,
	SSR_CODE_MEAL_HOT,
	SSR_CODE_MEAL_KOSHER,
	SSR_CODE_MEAL_LOW_CALORIE,
	SSR_CODE_MEAL_LOW_FAT,
	SSR_CODE_MEAL_LOW_SALT,
	SSR_CODE_MEAL_MEAT,
	SSR_CODE_MEAL_MUSLIM,
	SSR_CODE_MEAL_LACTOSE_FREE,
	SSR_CODE_MEAL_POULTRY,
	SSR_CODE_MEAL_PASTA,
	SSR_CODE_SEAFOOD_2,
	SSR_CODE_MEAL_SPECIAL,
	SSR_CODE_MEAL_VEGETARIAN,
	SSR_CODE_MEAL_VEGETATIAN_LACTO,
	SSR_CODE_MUSIC_INSTRUMENT_SMALL,
	SSR_CODE_MUSIC_INSTRUMENT_MEDIUM,
	SSR_CODE_MUSIC_INSTRUMENT_LARGE,
	SSR_CODE_SPORTS_EQUIPMENT_BIKE,
	SSR_CODE_SPORTS_EQUIPMENT_FISH,
	SSR_CODE_SPORTS_EQUIPMENT_GOLF,
	SSR_CODE_SPORTS_EQUIPMENT_HANG_GLIDER,
	SSR_CODE_SPORTS_EQUIPMENT_KITE,
	SSR_CODE_SPORTS_EQUIPMENT_LONG_BOARD,
	SSR_CODE_SPORTS_EQUIPMENT_PARAGLIDER,
	SSR_CODE_SPORTS_EQUIPMENT_POLE_VAULT,
	SSR_CODE_SPORTS_EQUIPMENT_SCUBA,
	SSR_CODE_SPORTS_EQUIPMENT_SKIM_BOARD,
	SSR_CODE_SPORTS_EQUIPMENT_SKI,
	SSR_CODE_SPORTS_SPORTING_EQUIPMENT,
	SSR_CODE_SPORTS_EQUIPMENT_SURF_BOARD,
	SSR_CODE_SPORTS_EQUIPMENT_WINDSURF,
	SSR_CODE_SEAT_BULKY_ITEMS,
	SSR_CODE_SEAT_EXTRA,
	SSR_CODE_SEAT_RESERVATION_1,
	SSR_CODE_SEAT_RESERVATION_2,
	SSR_CODE_FIREARMS,
	SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
	SSR_CODE_MEDICAL_ASSISTANCE,
	SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
	SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN,
	SSR_CODE_UNACCOMPANIED_MINOR,
	SSR_CODE_MEAL_SNACK,
	SSR_CODE_KIOSK,
	SSR_CODE_HAND_BAGGAGE,
	SSR_CODE_STANDARD_SEAT_RESERVATION,
	SSR_CODE_PREMIUM_BOARDING,
	SSR_CODE_PRIORITY_CHECK_IN,
	SSR_CODE_LOUNGE_ACCESS_2,
	SSR_CODE_PREMIUM_CUSTOMER_CENTER,
	SSR_CODE_FREE_SEAT_RESERVATION,
	SSR_CODE_SEAT_BABY_SEAT,
	SSR_CODE_SEAT,
	SSR_CODE_HAND_BAGGAGE_X2,
	SSR_CODE_HAND_BAGGAGE_10,
	SSR_CODE_HAND_BAGGAGE_10x2,
	SSR_CODE_BAGGAGE_FIRST_BAG_X2,
	SSR_CODE_BAGGAGE_FIRST_BAG_X3,
	SSR_CODE_MEAL_MEALS_AND_BEVERAGES,
	SSR_CODE_KIOSK_X2,
	SSR_CODE_KIOSK_X3,
	SSR_CODE_KIOSK_X7,
	SSR_CODE_PREFERED_ZONE_SEAT,
	SSR_CODE_BAGGAGE_PRIORITY,
	SSR_CODE_BAGGAGE_32_BAG_X2,
	SSR_CODE_BAGGAGE_32_BAG_X3,
	SSR_CODE_PERSONAL_ITEM,
	SSR_CODE_DEPORTEES_2,
	SSR_CODE_DEPORTEES_1,
	SSR_CODE_UM_EXTRA_ASSISTANT,
	SSR_CODE_INADMISSIBLE,
	SSR_CODE_RECLUSE,
	SSR_CODE_PREF_BOARD,
	SSR_CODE_BAGGAGE_PACK} from '@ibe.config';

// Start of ancillaries constants for what's included

export const PURCHASED_ANCILLARY_ANIMALS = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'pets' },
	icon: '',
	name: 'Small pets',
	id: 'pets'
};

export const PURCHASED_ANCILLARY_BAGGAGGE = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'details-luggage' },
	icon: '',
	name: '1x 8kg allowed',
	id: 'baggage'
};

export const PURCHASED_ANCILLARY_FAST_TRACK = {
	label: '',
	description: '',
	type: 'extra',
	icon: '',
	details: { label: 'Learn more', route: 'details-fast_track' },
	name: '1x 8kg allowed',
	id: 'fast-track'
};

export const PURCHASED_ANCILLARY_LOUNGE = {
	label: '',
	description: '',
	type: 'extra',
	icon: '',
	details: { label: 'Learn more', route: 'details-lounge' },
	name: 'Lounge',
	id: 'lounge'
};

export const PURCHASED_ANCILLARY_MEAL = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'details-snacks' },
	icon: '',
	name: 'Meals',
	id: 'meals'
};

export const PURCHASED_ANCILLARY_MUSICAL = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'musical-equipment' },
	icon: '',
	name: 'Music instruments',
	id: 'instruments'
};

export const PURCHASED_ANCILLARY_SPORTS_EQUIPMENT = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'sports-equipment' },
	icon: '',
	name: 'Sports equipments',
	id: 'sports'
};

export const PURCHASED_ANCILLARY_EXTRA_SEAT = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'details-seat' },
	icon: '',
	name: 'Extra seat',
	id: 'extraseat'
};

export const PURCHASED_ANCILLARY_KIOSK = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'details-kiosk' },
	icon: '',
	name: 'Kiosk',
	id: 'Kiosk'
};

export const PURCHASED_ANCILLARY_HAND_BAGGAGE = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'details-hand_luggage' },
	icon: '',
	name: 'Hand baggage',
	id: 'Hand baggage'
};

export const PURCHASED_ANCILLARY_PREMIUM_BOARDING = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'premium-boarding' },
	icon: '',
	name: 'Premium boarding',
	id: 'Premium boarding'
};

export const PURCHASED_ANCILLARY_PRIORITY_CHECK_IN = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'priority-checkin' },
	icon: '',
	name: 'Priority Check In',
	id: 'Priority Check In'
};

export const PURCHASED_ANCILLARY_PREMIUM_CUSTOMER_CENTER = {
	label: '',
	description: '',
	type: 'extra',
	details: { label: 'Learn more', route: 'premium-customer-centre' },
	icon: '',
	name: 'Premium Customer Centre',
	id: 'Premium Customer Centre'
};

// End of ancillaries constants for what's included

// For Extra Features
export const PURCHASED_ANCILLARY_BAG = {
	label: 'Baggage',
	description: '',
	type: 'BAG',
	action: { label: 'add', route: 'checked-bags' },
	icon: 'ancillaries--luggage',
	name: 'Checked bags',
	translation: 'priceBreakdown.ancillaries.text.checkedBags',
	id: 'bags',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: [SSR_CODE_DEPORTEES_1,
		SSR_CODE_DEPORTEES_2,
		SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
		SSR_CODE_UM_EXTRA_ASSISTANT,
		SSR_CODE_INADMISSIBLE,
		SSR_CODE_MEDICAL_ASSISTANCE,
		SSR_CODE_RECLUSE,
		SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
		SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN
	]
};

export const PURCHASED_ANCILLARY_SEAT = {
	label: 'Choose a seating area from 12,00€',
	description: 'Seats from 12€',
	type: 'SEAT',
	action: { label: 'Choose', route: 'seatmap' },
	icon: 'plane_related--seat',
	name: 'Seats',
	translation: 'priceBreakdown.ancillaries.text.seats',
	id: 'seats',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: [SSR_CODE_DEPORTEES_1,
		SSR_CODE_DEPORTEES_2,
		SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
		SSR_CODE_UM_EXTRA_ASSISTANT,
		SSR_CODE_SEAT_EXTRA,
		SSR_CODE_INADMISSIBLE,
		SSR_CODE_MEDICAL_ASSISTANCE,
		SSR_CODE_RECLUSE,
		SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
		SSR_CODE_SPECIAL_NEEDS_SERVICE_ANIMAL,
		SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN,
		SSR_CODE_BAGGAGE_BULKY_BAG,
		SSR_CODE_SEAT_BULKY_ITEMS
	]
};

export const PURCHASED_ANCILLARY_EQUIPMENT = {
	label: 'Special Equipment',
	description: '',
	type: 'EQUIPMENT',
	action: { label: 'Choose', route: 'ancillaries--sports_equipment' },
	icon: 'ancillaries--sports_equipment',
	name: 'Sports equipments',
	translation: 'priceBreakdown.ancillaries.text.sports',
	id: 'sports',
	hoursAvailableBeforeFlight: 24,
	ineligibleSSR: [SSR_CODE_DEPORTEES_1,
		SSR_CODE_DEPORTEES_2,
		SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
		SSR_CODE_UM_EXTRA_ASSISTANT,
		SSR_CODE_INADMISSIBLE,
		SSR_CODE_MEDICAL_ASSISTANCE,
		SSR_CODE_RECLUSE,
		SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
		SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN
	]
};

export const PURCHASED_ANCILLARY_EXTRA_ANIMAL = {
	label: 'Animals',
	description: '',
	// type: 'extra',
	type: 'PET',
	action: { label: 'Choose', route: 'ancillaries--small-pets' },
	// icon: 'special_needs--dog_assistance',
	icon: 'luggage--small_pets',
	name: 'Small pets',
	translation: 'priceBreakdown.ancillaries.text.smallPets',
	id: 'pets',
	hoursAvailableBeforeFlight: 24,
	ineligibleSSR: [SSR_CODE_DEPORTEES_1,
		SSR_CODE_DEPORTEES_2,
		SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
		SSR_CODE_UM_EXTRA_ASSISTANT,
		SSR_CODE_INADMISSIBLE,
		SSR_CODE_MEDICAL_ASSISTANCE,
		SSR_CODE_RECLUSE,
		SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
		SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN,
		SSR_CODE_UNACCOMPANIED_MINOR,
		SSR_CODE_SPECIAL_NEEDS_SERVICE_ANIMAL
	]
};

export const PURCHASED_ANCILLARY_EXTRA_MEAL = {
	label: 'Meal',
	description: '',
	type: 'MEAL',
	action: { label: 'Choose', route: 'ancillaries--special-meals' },
	icon: 'ancillaries--meals',
	name: 'meals',
	translation: 'priceBreakdown.ancillaries.text.meal',
	id: 'meals',
	hoursAvailableBeforeFlight: 24,
	ineligibleSSR: [SSR_CODE_DEPORTEES_1,
		SSR_CODE_DEPORTEES_2,
		SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
		SSR_CODE_UM_EXTRA_ASSISTANT,
		SSR_CODE_INADMISSIBLE,
		SSR_CODE_MEDICAL_ASSISTANCE,
		SSR_CODE_RECLUSE,
		SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
		SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN
	]
};

export const PURCHASED_ANCILLARY_EXTRA_FAST_TRACK = {
	label: 'Fast Track',
	description: '',
	// type: 'extra',
	type: 'FASTTRACK',
	action: { label: 'add', route: 'fast-track' },
	icon: 'plane_related--fast_track',
	name: 'Fast track',
	translation: 'priceBreakdown.ancillaries.text.fastTrack',
	id: 'fasttrack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: [SSR_CODE_DEPORTEES_1,
		SSR_CODE_DEPORTEES_2,
		SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
		SSR_CODE_UM_EXTRA_ASSISTANT,
		SSR_CODE_INADMISSIBLE,
		SSR_CODE_MEDICAL_ASSISTANCE,
		SSR_CODE_RECLUSE,
		SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
		SSR_CODE_UNACCOMPANIED_MINOR,
		SSR_CODE_WHEELCHAIR_CARRY,
		SSR_CODE_WHEELCHAIR_RAMP,
		SSR_CODE_WHEELCHAIR_STEPS,
		SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN
	]
};

export const PURCHASED_ANCILLARY_EXTRA_LOUNGE = {
	label: 'Lounge',
	description: '',
	// type: 'extra',
	type: 'LOUNGE',
	action: { label: 'add', route: 'ancillaries--lounge' },
	icon: 'ancillaries--lounge',
	name: 'Lounge',
	translation: 'priceBreakdown.ancillaries.text.lounge',
	id: 'lounge',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: [SSR_CODE_DEPORTEES_1,
		SSR_CODE_DEPORTEES_2,
		SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
		SSR_CODE_UM_EXTRA_ASSISTANT,
		SSR_CODE_INADMISSIBLE,
		SSR_CODE_MEDICAL_ASSISTANCE,
		SSR_CODE_RECLUSE,
		SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
		SSR_CODE_UNACCOMPANIED_MINOR,
		SSR_CODE_WHEELCHAIR_CARRY,
		SSR_CODE_WHEELCHAIR_RAMP,
		SSR_CODE_WHEELCHAIR_STEPS,
		SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN
	]
};

export const PURCHASED_ANCILLARY_EXTRA_MUSICAL = {
	label: 'Musical',
	description: '',
	// type: 'extra',
	type: 'MUSICAL',
	action: { label: 'add', route: 'ancillaries--music-instruments' },
	icon: 'luggage--music_equipment',
	name: 'Musical',
	translation: 'priceBreakdown.ancillaries.text.musical',
	id: 'musical',
	hoursAvailableBeforeFlight: 24,
	ineligibleSSR: [SSR_CODE_DEPORTEES_1,
		SSR_CODE_DEPORTEES_2,
		SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
		SSR_CODE_UM_EXTRA_ASSISTANT,
		SSR_CODE_INADMISSIBLE,
		SSR_CODE_MEDICAL_ASSISTANCE,
		SSR_CODE_RECLUSE,
		SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
		SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN
	]
};

//TODO: UPDATE DETAILS FOR PREF BOARDING
export const PURCHASED_ANCILLARY_PREF_BOARD = {
	label: 'Preferred Boarding',
	description: '',
	type: 'PREFERRED_BOARDING',
	action: { label: 'add', route: 'preferred-boarding' },
	icon: 'plane_related--preferred-board',
	name: 'Preferred Boarding',
	translation: 'priceBreakdown.ancillaries.text.prefBoard',
	id: 'prefBoard',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: [SSR_CODE_DEPORTEES_1,
		SSR_CODE_DEPORTEES_2,
		SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL,
		SSR_CODE_UM_EXTRA_ASSISTANT,
		SSR_CODE_SEAT_EXTRA,
		SSR_CODE_INADMISSIBLE,
		SSR_CODE_MEDICAL_ASSISTANCE,
		SSR_CODE_RECLUSE,
		SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER,
		SSR_CODE_SPECIAL_NEEDS_SERVICE_ANIMAL,
		SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN,
		SSR_CODE_BAGGAGE_BULKY_BAG,
		SSR_CODE_SEAT_BULKY_ITEMS
	]
};

export const PURCHASED_ANCILLARY_PACK = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: [],
}

export const PURCHASED_ANCILLARY_PACK_PAAG = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAG',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAB = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAB',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAA = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAA',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAI = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAI',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAQ = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAQ',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAD = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAD',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAE = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAE',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAF = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAF',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAC = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAC',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAH = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAH',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAO = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAO',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAT = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAT',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PAAR = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PAAR',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}


export const PURCHASED_ANCILLARY_PACK_PBAT = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PBAT',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PBAA = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PBAA',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export const PURCHASED_ANCILLARY_PACK_PBAB = {
	label: 'Pack',
	description: '',
	type: 'PACK',
	action: { label: 'add', route: 'packs' },
	icon: 'ancillaries--bundle',
	name: 'Pack',
	translation: 'priceBreakdown.ancillaries.text.pack.PBAB',
	id: 'pack',
	hoursAvailableBeforeFlight: 6,
	ineligibleSSR: []
}

export class INDRAFeaturesDetails {
	label: string;
	route: string;
}

export class INDRAFeature {
	label: string;
	type: string;
	description?: string;
	icon: string;
	details?: INDRAFeaturesDetails;

	static createByCode(ssrCode: string, review: boolean) {
		let returnObject;
		switch (ssrCode) {
			//////////////// PRMs ////////////////
			case SSR_CODE_WHEELCHAIR_CARRY:
			case SSR_CODE_WHEELCHAIR_RAMP:
			case SSR_CODE_WHEELCHAIR_STEPS:
			case SSR_CODE_WHEELCHAIR_MANUAL_POWER:
			case SSR_CODE_WHEELCHAIR_DRY_CELL_BATTERY:
			case SSR_CODE_WHEELCHAIR_WET_CELL_BATTERY:
			case SSR_CODE_WHEELCHAIR_LITHIUM_ION_BATTERY:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-wheelchair-access' },
					icon: 'special_needs--wheelchair_access',
					name: 'Wheelchair',
					id: 'Wheelchair'
				};
				break;

			case SSR_CODE_SPECIAL_NEEDS_SERVICE_ANIMAL:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-service-animal' },
					icon: 'special_needs--dog_assistance',
					name: 'Service Animal',
					id: 'service animal'
				};
				break;

			case SSR_CODE_SPECIAL_NEEDS_BLIND_ASSISTANCE:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-blind-assistance' },
					icon: 'special_needs--blind_person',
					name: 'Blind Assistance',
					id: 'blind assistance'
				};
				break;

			case SSR_CODE_SPECIAL_NEEDS_DEAF_ASSISTANCE:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-deaf-assistance' },
					icon: 'special_needs--deaf_assistance',
					name: 'Deaf Assistance',
					id: 'deaf assistance'
				};
				break;

			case SSR_CODE_LUGGAGE_BABY_BASKET:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-baby-basket' },
					icon: 'luggage--baby_basket',
					name: '',
					id: 'baby-basket'
				};
				break;
			//////////////// ANCILLARIES ////////////////
			case SSR_CODE_ANIMAL_IN_HOLD:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-animal-in-hold' },
					icon: 'luggage--pet_hand_transporter',
					name: '',
					id: 'animal-in-hold'
				};
				break;

			case SSR_CODE_PET_IN_CABIN:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'pets' },
					icon: 'luggage--small_pets',
					name: 'Small pets',
					id: 'pets'
				};
				break;

			case SSR_CODE_BAGGAGE_FIRST_BAG:
			case SSR_CODE_BAGGAGE_SECOND_BAG:
			case SSR_CODE_BAGGAGE_ADDITIONAL_BAG:
			case SSR_CODE_BAGGAGE_FIRST_BAG_X2:
			case SSR_CODE_BAGGAGE_FIRST_BAG_X3:
			case SSR_CODE_BAGGAGE_32_BAG_X2:
			case SSR_CODE_BAGGAGE_32_BAG_X3:
			case SSR_CODE_BAGGAGE_PACK:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: (review ? 'flight-details-luggage' : 'details-luggage') },
					icon: 'ancillaries--luggage',
					name: '1x 8kg allowed',
					id: 'baggage'
				};
				break;

			case SSR_CODE_BAGGAGE_PRIORITY:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: (review ? 'flight-details-priority-luggage' : 'details-priority-luggage') },
					icon: 'luggage--priority',
					name: 'Priority Baggage',
					id: 'priority-baggage'
				};
				break;

			case SSR_CODE_BAGGAGE_BULKY_BAG:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-bulky_luggage' },
					icon: 'luggage--bulky_baggage',
					name: '',
					id: 'bulky_luggage'
				};
				break;

			case SSR_CODE_FAST_TRACK:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					icon: 'plane_related--fast_track',
					details: { label: 'Learn more', route: (review ? 'flight-details-fast_track' : 'details-fast_track') },
					name: '',
					id: 'fast-track'
				};
				break;

			case SSR_CODE_LOUNGE_ACCESS_1:
			case SSR_CODE_LOUNGE_ACCESS_2:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					icon: 'ancillaries--lounge',
					details: { label: 'Learn more', route: (review ? 'flight-details-lounge' : 'details-lounge') },
					name: 'Lounge',
					id: 'lounge'
				};
				break;

			case SSR_CODE_MEAL_HINDU_VEGETARIAN:
			case SSR_CODE_MEAL_BABY:
			case SSR_CODE_MEAL_BLAND:
			case SSR_CODE_MEAL_CHILD:
			case SSR_CODE_MEAL_COLD:
			case SSR_CODE_MEAL_SEAFOOD_1:
			case SSR_CODE_MEAL_DIABETICS:
			case SSR_CODE_MEAL_FRUIT_PLATTER:
			case SSR_CODE_MEAL_FISH:
			case SSR_CODE_MEAL_GLUTEN_FREE:
			case SSR_CODE_MEAL_HINDU:
			case SSR_CODE_MEAL_HOT:
			case SSR_CODE_MEAL_KOSHER:
			case SSR_CODE_MEAL_LOW_CALORIE:
			case SSR_CODE_MEAL_LOW_FAT:
			case SSR_CODE_MEAL_LOW_SALT:
			case SSR_CODE_MEAL_MEAT:
			case SSR_CODE_MEAL_MUSLIM:
			case SSR_CODE_MEAL_LACTOSE_FREE:
			case SSR_CODE_MEAL_POULTRY:
			case SSR_CODE_MEAL_PASTA:
			case SSR_CODE_SEAFOOD_2:
			case SSR_CODE_MEAL_SPECIAL:
			case SSR_CODE_MEAL_VEGETARIAN:
			case SSR_CODE_MEAL_VEGETATIAN_LACTO:
			case SSR_CODE_MEAL_MEALS_AND_BEVERAGES:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: (review ? 'flight-details-meals' : 'details-snacks') },
					icon: 'food_drinks--cold_meals',
					name: 'Meals',
					id: 'meals'
				};
				break;

			case SSR_CODE_MEAL_SNACK:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: (review ? 'flight-details-snacks' : 'details-snacks') },
					icon: 'food_drinks--cold_meals',
					name: 'Snack and Beverage',
					id: 'meals'
				};
				break;

			case SSR_CODE_MUSIC_INSTRUMENT_SMALL:
			case SSR_CODE_MUSIC_INSTRUMENT_MEDIUM:
			case SSR_CODE_MUSIC_INSTRUMENT_LARGE:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'musical-equipment' },
					icon: 'luggage--music_equipment',
					name: 'Music instruments',
					id: 'instruments'
				};
				break;

			case SSR_CODE_SPORTS_EQUIPMENT_BIKE:
			case SSR_CODE_SPORTS_EQUIPMENT_FISH:
			case SSR_CODE_SPORTS_EQUIPMENT_GOLF:
			case SSR_CODE_SPORTS_EQUIPMENT_HANG_GLIDER:
			case SSR_CODE_SPORTS_EQUIPMENT_KITE:
			case SSR_CODE_SPORTS_EQUIPMENT_LONG_BOARD:
			case SSR_CODE_SPORTS_EQUIPMENT_PARAGLIDER:
			case SSR_CODE_SPORTS_EQUIPMENT_POLE_VAULT:
			case SSR_CODE_SPORTS_EQUIPMENT_SCUBA:
			case SSR_CODE_SPORTS_EQUIPMENT_SKIM_BOARD:
			case SSR_CODE_SPORTS_EQUIPMENT_SKI:
			case SSR_CODE_SPORTS_SPORTING_EQUIPMENT:
			case SSR_CODE_SPORTS_EQUIPMENT_SURF_BOARD:
			case SSR_CODE_SPORTS_EQUIPMENT_WINDSURF:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'sports-equipment' },
					icon: 'ancillaries--sports_equipment',
					name: 'Sports equipments',
					id: 'sports'
				};
				break;

			case SSR_CODE_SEAT_BULKY_ITEMS:
			case SSR_CODE_SEAT_BABY_SEAT:
			case SSR_CODE_SEAT_EXTRA:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-extra-seat' },
					icon: 'plane_related--extra_seat',
					name: 'Extra Seat',
					id: 'extra seat'
				};
				break;

			case SSR_CODE_SEAT_RESERVATION_1:
			case SSR_CODE_SEAT_RESERVATION_2:
			case SSR_CODE_STANDARD_SEAT_RESERVATION:
			case SSR_CODE_FREE_SEAT_RESERVATION:
			case SSR_CODE_SEAT:
			case SSR_CODE_PREFERED_ZONE_SEAT:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: (review ? 'flight-details-seat' : 'details-seat') },
					icon: 'plane_related--seat',
					name: 'Extra seat',
					id: 'extraseat'
				};
				break;

			case SSR_CODE_FIREARMS:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-weapon' },
					icon: 'luggage--weapon',
					name: 'Weapon',
					id: 'weapon'
				};
				break;

			case SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL:
			case SSR_CODE_MEDICAL_ASSISTANCE:
			case SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER:
			case SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-medical-assistance' },
					icon: 'special_needs--health',
					name: 'Medical Assistance',
					id: 'medical assistance'
				};
				break;

			case SSR_CODE_UNACCOMPANIED_MINOR:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'details-unaccompanied-minor' },
					icon: 'services--assistant_unaccompanied_minor',
					name: 'Unaccompanied Minor',
					id: 'unaccompanied minor'
				};
				break;

			case SSR_CODE_KIOSK:
			case SSR_CODE_KIOSK_X2:
			case SSR_CODE_KIOSK_X3:
			case SSR_CODE_KIOSK_X7:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: (review ? 'flight-details-kiosk' : 'details-kiosk') },
					icon: 'leisure_and_commodities--magazines',
					name: 'Kiosk',
					id: 'Kiosk'
				};
				break;

			case SSR_CODE_HAND_BAGGAGE:
			case SSR_CODE_HAND_BAGGAGE_10:
			case SSR_CODE_HAND_BAGGAGE_X2:
			case SSR_CODE_HAND_BAGGAGE_10x2:
			case SSR_CODE_PERSONAL_ITEM:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: (review ? 'flight-details-hand_luggage' : 'details-hand_luggage') },
					icon: 'luggage--cabin_trolley',
					name: 'Hand baggage',
					id: 'Hand baggage'
				};
				break;

			case SSR_CODE_PREMIUM_BOARDING:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: (review ? 'flight-details-differentiated_boarding' : 'premium-boarding') },
					icon: 'airport--differentiated_boarding',
					name: 'Premium boarding',
					id: 'Premium boarding'
				};
				break;

			case SSR_CODE_PRIORITY_CHECK_IN:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: (review ? 'flight-details-priority-checkin' : 'priority-checkin') },
					icon: 'check-in--priority',
					name: 'Priority Check In',
					id: 'Priority Check In'
				};
				break;

			case SSR_CODE_PREMIUM_CUSTOMER_CENTER:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: (review ? 'flight-details-premium-customer-centre' : 'premium-customer-centre') },
					icon: 'support--premium_customer_service',
					name: 'Premium Customer Centre',
					id: 'Premium Customer Centre'
				};
				break;

			case SSR_CODE_PREF_BOARD:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: 'preferred-boarding' },
					icon: 'plane_related--preferred-board',
					name: 'Preferred Boarding',
					id: 'Preferred Boarding'
				};
				break;

			case '':
			default:
				returnObject = {
					label: '',
					description: '',
					type: 'extra',
					details: { label: 'Learn more', route: '' },
					icon: 'general--not_available',
					name: 'Temporary only',
					id: 'dummy'
				}; // TODO
				break;
		}

		// returnObject.icon = this.getIconForSSRCode(ssrCode);
		// returnObject.label = this.getLabelsForSSRCode(ssrCode);
		return returnObject;
	}

	static getIconForSSRCode(ssrCode: string) {
		switch (ssrCode) {
			//////////////// PRMs ////////////////
			case SSR_CODE_WHEELCHAIR_CARRY:
			case SSR_CODE_WHEELCHAIR_RAMP:
			case SSR_CODE_WHEELCHAIR_STEPS:
			case SSR_CODE_WHEELCHAIR_MANUAL_POWER:
			case SSR_CODE_WHEELCHAIR_DRY_CELL_BATTERY:
			case SSR_CODE_WHEELCHAIR_WET_CELL_BATTERY:
			case SSR_CODE_WHEELCHAIR_LITHIUM_ION_BATTERY:
				return 'special_needs--wheelchair_access';

			case SSR_CODE_SPECIAL_NEEDS_SERVICE_ANIMAL:
				return 'special_needs--dog_assistance';

			case SSR_CODE_SPECIAL_NEEDS_BLIND_ASSISTANCE:
				return 'special_needs--blind_person';

			case SSR_CODE_SPECIAL_NEEDS_DEAF_ASSISTANCE:
				return 'special_needs--deaf_assistance';

			case SSR_CODE_LUGGAGE_BABY_BASKET:
				return 'luggage--baby_basket';
			//////////////// ANCILLARIES ////////////////
			case SSR_CODE_ANIMAL_IN_HOLD:
				return 'luggage--pet_hand_transporter';

			case SSR_CODE_PET_IN_CABIN:
				return 'luggage--small_pets';

			case SSR_CODE_BAGGAGE_FIRST_BAG:
			case SSR_CODE_BAGGAGE_SECOND_BAG:
			case SSR_CODE_BAGGAGE_ADDITIONAL_BAG:
			case SSR_CODE_BAGGAGE_FIRST_BAG_X2:
			case SSR_CODE_BAGGAGE_FIRST_BAG_X3:
			case SSR_CODE_BAGGAGE_32_BAG_X2:
			case SSR_CODE_BAGGAGE_32_BAG_X3:
				return 'ancillaries--luggage';

			case SSR_CODE_BAGGAGE_PRIORITY:
				return 'luggage--priority';

			case SSR_CODE_BAGGAGE_BULKY_BAG:
				return 'luggage--bulky_baggage';

			case SSR_CODE_FAST_TRACK:
				return 'plane_related--fast_track';

			case SSR_CODE_LOUNGE_ACCESS_1:
			case SSR_CODE_LOUNGE_ACCESS_2:
				return 'ancillaries--lounge';

			case SSR_CODE_MEAL_HINDU_VEGETARIAN:
			case SSR_CODE_MEAL_BABY:
			case SSR_CODE_MEAL_BLAND:
			case SSR_CODE_MEAL_CHILD:
			case SSR_CODE_MEAL_COLD:
			case SSR_CODE_MEAL_SEAFOOD_1:
			case SSR_CODE_MEAL_DIABETICS:
			case SSR_CODE_MEAL_FRUIT_PLATTER:
			case SSR_CODE_MEAL_FISH:
			case SSR_CODE_MEAL_GLUTEN_FREE:
			case SSR_CODE_MEAL_HINDU:
			case SSR_CODE_MEAL_HOT:
			case SSR_CODE_MEAL_KOSHER:
			case SSR_CODE_MEAL_LOW_CALORIE:
			case SSR_CODE_MEAL_LOW_FAT:
			case SSR_CODE_MEAL_LOW_SALT:
			case SSR_CODE_MEAL_MEAT:
			case SSR_CODE_MEAL_MUSLIM:
			case SSR_CODE_MEAL_LACTOSE_FREE:
			case SSR_CODE_MEAL_POULTRY:
			case SSR_CODE_MEAL_PASTA:
			case SSR_CODE_SEAFOOD_2:
			case SSR_CODE_MEAL_SPECIAL:
			case SSR_CODE_MEAL_VEGETARIAN:
			case SSR_CODE_MEAL_VEGETATIAN_LACTO:
			case SSR_CODE_MEAL_SNACK:
			case SSR_CODE_MEAL_MEALS_AND_BEVERAGES:
				return 'food_drinks--cold_meals';

			case SSR_CODE_MUSIC_INSTRUMENT_SMALL:
			case SSR_CODE_MUSIC_INSTRUMENT_MEDIUM:
			case SSR_CODE_MUSIC_INSTRUMENT_LARGE:
				return 'luggage--music_equipment';

			case SSR_CODE_SPORTS_EQUIPMENT_BIKE:
			case SSR_CODE_SPORTS_EQUIPMENT_FISH:
			case SSR_CODE_SPORTS_EQUIPMENT_GOLF:
			case SSR_CODE_SPORTS_EQUIPMENT_HANG_GLIDER:
			case SSR_CODE_SPORTS_EQUIPMENT_KITE:
			case SSR_CODE_SPORTS_EQUIPMENT_LONG_BOARD:
			case SSR_CODE_SPORTS_EQUIPMENT_PARAGLIDER:
			case SSR_CODE_SPORTS_EQUIPMENT_POLE_VAULT:
			case SSR_CODE_SPORTS_EQUIPMENT_SCUBA:
			case SSR_CODE_SPORTS_EQUIPMENT_SKIM_BOARD:
			case SSR_CODE_SPORTS_EQUIPMENT_SKI:
			case SSR_CODE_SPORTS_SPORTING_EQUIPMENT:
			case SSR_CODE_SPORTS_EQUIPMENT_SURF_BOARD:
			case SSR_CODE_SPORTS_EQUIPMENT_WINDSURF:
				return 'ancillaries--sports_equipment';

			case SSR_CODE_SEAT_BULKY_ITEMS:
			case SSR_CODE_SEAT_BABY_SEAT:
			case SSR_CODE_SEAT_EXTRA:
				return 'plane_related--extra_seat';

			case SSR_CODE_SEAT_RESERVATION_1:
			case SSR_CODE_SEAT_RESERVATION_2:
			case SSR_CODE_STANDARD_SEAT_RESERVATION:
			case SSR_CODE_FREE_SEAT_RESERVATION:
			case SSR_CODE_SEAT:
			case SSR_CODE_PREFERED_ZONE_SEAT:
				return 'plane_related--seat';

			case SSR_CODE_FIREARMS:
				return 'luggage--weapon';

			case SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL:
			case SSR_CODE_MEDICAL_ASSISTANCE:
			case SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER:
			case SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN:
				return 'special_needs--health';

			case SSR_CODE_UNACCOMPANIED_MINOR:
				return 'services--assistant_unaccompanied_minor';

			case SSR_CODE_KIOSK:
			case SSR_CODE_KIOSK_X2:
			case SSR_CODE_KIOSK_X3:
			case SSR_CODE_KIOSK_X7:
				return 'leisure_and_commodities--magazines';

			case SSR_CODE_HAND_BAGGAGE:
			case SSR_CODE_HAND_BAGGAGE_10:
			case SSR_CODE_HAND_BAGGAGE_X2:
			case SSR_CODE_HAND_BAGGAGE_10x2:
			case SSR_CODE_PERSONAL_ITEM:
				return 'luggage--cabin_trolley';

			case SSR_CODE_PREMIUM_BOARDING:
				return 'airport--differentiated_boarding';

			case SSR_CODE_PRIORITY_CHECK_IN:
				return 'check-in--priority';

			case SSR_CODE_PREMIUM_CUSTOMER_CENTER:
				return 'support--premium_customer_service';

			case SSR_CODE_PREF_BOARD:
				return 'plane_related--preferred-board';


			case '':
			default:
				return 'general--not_available';
		}
	}

	static getLabelsForSSRCode(ssrCode: string) {
		switch (ssrCode) {
			//////////////// PRMs ////////////////
			case SSR_CODE_WHEELCHAIR_CARRY:
			case SSR_CODE_WHEELCHAIR_RAMP:
			case SSR_CODE_WHEELCHAIR_STEPS:
			case SSR_CODE_WHEELCHAIR_MANUAL_POWER:
			case SSR_CODE_WHEELCHAIR_DRY_CELL_BATTERY:
			case SSR_CODE_WHEELCHAIR_WET_CELL_BATTERY:
			case SSR_CODE_WHEELCHAIR_LITHIUM_ION_BATTERY:
				return 'Wheelchair';

			case SSR_CODE_SPECIAL_NEEDS_SERVICE_ANIMAL:
				return 'Service animal';

			case SSR_CODE_SPECIAL_NEEDS_BLIND_ASSISTANCE:
				return 'Blind assistance';

			case SSR_CODE_SPECIAL_NEEDS_DEAF_ASSISTANCE:
				return 'Deaf assistance';

			case SSR_CODE_LUGGAGE_BABY_BASKET:
				return 'Baby basket';
			//////////////// ANCILLARIES ////////////////
			case SSR_CODE_ANIMAL_IN_HOLD:
				return 'Animal in the hold';

			case SSR_CODE_PET_IN_CABIN:
				return 'Pet';

			case SSR_CODE_BAGGAGE_FIRST_BAG:
			case SSR_CODE_BAGGAGE_SECOND_BAG:
			case SSR_CODE_BAGGAGE_ADDITIONAL_BAG:
			case SSR_CODE_BAGGAGE_FIRST_BAG_X2:
			case SSR_CODE_BAGGAGE_FIRST_BAG_X3:
			case SSR_CODE_BAGGAGE_32_BAG_X2:
			case SSR_CODE_BAGGAGE_32_BAG_X3:
				return 'Checked baggage';

			case SSR_CODE_BAGGAGE_PRIORITY:
				return 'Priority baggage';

			case SSR_CODE_BAGGAGE_BULKY_BAG:
				return 'Bulky baggage';

			case SSR_CODE_FAST_TRACK:
				return 'Fast track';

			case SSR_CODE_LOUNGE_ACCESS_1:
			case SSR_CODE_LOUNGE_ACCESS_2:
				return 'Lounge access';

			case SSR_CODE_MEAL_HINDU_VEGETARIAN:
			case SSR_CODE_MEAL_BABY:
			case SSR_CODE_MEAL_BLAND:
			case SSR_CODE_MEAL_CHILD:
			case SSR_CODE_MEAL_COLD:
			case SSR_CODE_MEAL_SEAFOOD_1:
			case SSR_CODE_MEAL_DIABETICS:
			case SSR_CODE_MEAL_FRUIT_PLATTER:
			case SSR_CODE_MEAL_FISH:
			case SSR_CODE_MEAL_GLUTEN_FREE:
			case SSR_CODE_MEAL_HINDU:
			case SSR_CODE_MEAL_HOT:
			case SSR_CODE_MEAL_KOSHER:
			case SSR_CODE_MEAL_LOW_CALORIE:
			case SSR_CODE_MEAL_LOW_FAT:
			case SSR_CODE_MEAL_LOW_SALT:
			case SSR_CODE_MEAL_MEAT:
			case SSR_CODE_MEAL_MUSLIM:
			case SSR_CODE_MEAL_LACTOSE_FREE:
			case SSR_CODE_MEAL_POULTRY:
			case SSR_CODE_MEAL_PASTA:
			case SSR_CODE_SEAFOOD_2:
			case SSR_CODE_MEAL_SPECIAL:
			case SSR_CODE_MEAL_VEGETARIAN:
			case SSR_CODE_MEAL_VEGETATIAN_LACTO:
			case SSR_CODE_MEAL_SNACK:
			case SSR_CODE_MEAL_MEALS_AND_BEVERAGES:
				return 'Meal';

			case SSR_CODE_MUSIC_INSTRUMENT_SMALL:
			case SSR_CODE_MUSIC_INSTRUMENT_MEDIUM:
			case SSR_CODE_MUSIC_INSTRUMENT_LARGE:
				return 'Music instruments';

			case SSR_CODE_SPORTS_EQUIPMENT_BIKE:
			case SSR_CODE_SPORTS_EQUIPMENT_FISH:
			case SSR_CODE_SPORTS_EQUIPMENT_GOLF:
			case SSR_CODE_SPORTS_EQUIPMENT_HANG_GLIDER:
			case SSR_CODE_SPORTS_EQUIPMENT_KITE:
			case SSR_CODE_SPORTS_EQUIPMENT_LONG_BOARD:
			// case SSR_CODE_SPORTS_EQUIPMENT_PARAGLIDER:
			case SSR_CODE_SPORTS_EQUIPMENT_POLE_VAULT:
			case SSR_CODE_SPORTS_EQUIPMENT_SCUBA:
			case SSR_CODE_SPORTS_EQUIPMENT_SKIM_BOARD:
			case SSR_CODE_SPORTS_EQUIPMENT_SKI:
			case SSR_CODE_SPORTS_SPORTING_EQUIPMENT:
			case SSR_CODE_SPORTS_EQUIPMENT_SURF_BOARD:
				// case SSR_CODE_SPORTS_EQUIPMENT_WINDSURF:
				return 'Sports equipment';
			case SSR_CODE_SPORTS_EQUIPMENT_WINDSURF:
				return 'Windsurf equipment';
			case SSR_CODE_SPORTS_EQUIPMENT_PARAGLIDER:
				return 'Paraglider';
			case SSR_CODE_SEAT_BULKY_ITEMS:
			case SSR_CODE_SEAT_BABY_SEAT:
			case SSR_CODE_SEAT_EXTRA:
				return 'Extra seat';

			case SSR_CODE_SEAT_RESERVATION_1:
			case SSR_CODE_SEAT_RESERVATION_2:
			case SSR_CODE_STANDARD_SEAT_RESERVATION:
			case SSR_CODE_FREE_SEAT_RESERVATION:
			case SSR_CODE_SEAT:
			case SSR_CODE_PREFERED_ZONE_SEAT:
				return 'Seat reservation';

			case SSR_CODE_FIREARMS:
				// return 'Firearms';
				return '1 firearm & ammo box';

			case SSR_CODE_MEDICAL_ASSISTANCE_EMOTIONAL_SUPPORT_ANIMAL:
			case SSR_CODE_MEDICAL_ASSISTANCE:
			case SSR_CODE_MEDICAL_ASSISTANCE_STRETCHER:
			case SSR_CODE_MEDICAL_ASSISTANCE_OXYGEN:
				return 'Medical assistance';

			case SSR_CODE_UNACCOMPANIED_MINOR:
				return 'Unaccompanied minor';

			case SSR_CODE_KIOSK:
			case SSR_CODE_KIOSK_X2:
			case SSR_CODE_KIOSK_X3:
			case SSR_CODE_KIOSK_X7:
				return 'Digital Kiosk';

			case SSR_CODE_HAND_BAGGAGE:
			case SSR_CODE_HAND_BAGGAGE_10:
			case SSR_CODE_HAND_BAGGAGE_X2:
			case SSR_CODE_HAND_BAGGAGE_10x2:
			case SSR_CODE_PERSONAL_ITEM:
				return 'Hand baggage';

			case SSR_CODE_PREMIUM_BOARDING:
				return 'Premium Boarding';

			case SSR_CODE_PRIORITY_CHECK_IN:
				return 'Priority Check In';

			case SSR_CODE_PREMIUM_CUSTOMER_CENTER:
				return 'Premium Customer Centre';

			case SSR_CODE_PREF_BOARD:
				return 'Preferred Boarding';

			case '':
			default:
				return 'Ancillaries not mapped' + ' - ' + ssrCode;
		}
	}

	static getLoyaltyMiles(miles: string, review: boolean) {
		const returnObject = {
			label: miles + ' miles',
			valueLabel: miles,
			description: '',
			type: 'extra',
			details: { label: 'Learn more', route: (review ? 'flight-details-miles' : 'details-loyalty_miles') },
			icon: 'loyalty--miles',
			name: 'Miles',
			id: 'Miles',
			unconfirmed: []
		};
		return returnObject;
	}
	static getFFTierLevel(tierFF: string, pax: any) {
		const returnObject = {
			label: '',
			valueLabel: pax.name + ' ' + pax.surname,
			description: '',
			type: 'extra',
			details: { label: 'Learn more', route: 'passenger-included', id: pax.idPax },
			name: 'loyalty miles' + tierFF,
			id: 'loyalty miles'
		};
		return returnObject;
	}
}
